import ContactForm from "../components/ContactForm";
import Reveal from "../components/Reveal";

export default function Contact() {
  return (
    <>
      <section className="container-prose pt-16 sm:pt-24 pb-10 relative">
        <div
          aria-hidden
          className="orb -top-20 left-0 h-72 w-72 animate-float"
          style={{ background: "radial-gradient(closest-side, #d7c8ff, transparent)" }}
        />
        <Reveal>
          <span className="pill pill-lav">Contact</span>
          <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
            We'd love to <em className="not-italic grad-text">hear from you.</em>
          </h1>
          <p className="mt-6 text-lg text-ink-500 leading-relaxed">
            For waitlist requests please use the{" "}
            <a href="/elder-sanctuary" className="text-royal hover:text-royal-hi underline">
              Elder
            </a>{" "}
            or{" "}
            <a href="/orphan-sanctuary" className="text-royal hover:text-royal-hi underline">
              Orphan
            </a>{" "}
            Sanctuary pages — those forms reach the right team fastest. For
            anything else, this is the right place.
          </p>
        </Reveal>
      </section>

      <section className="container-wide py-10 grid gap-6 lg:grid-cols-5">
        <div className="lg:col-span-2 space-y-5">
          <Reveal>
            <div className="surface">
              <h3 className="font-display text-xl">Registered office</h3>
              <address className="not-italic mt-3 text-ink-700 leading-relaxed text-sm">
                <strong className="text-ink-900">
                  Sanctology Welfare Foundation
                </strong>
                <br />
                3/5, Panchayat Board St, Karuthapillaiyur
                <br />
                Tirunelveli, Tamil Nadu 627418
                <br />
                India
              </address>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="surface">
              <h3 className="font-display text-xl">Email</h3>
              <div className="mt-3 text-ink-700">
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-500">
                  Reach us at
                </div>
                <a
                  href="mailto:hope@sanctology.com"
                  className="hover:text-royal transition text-lg"
                >
                  hope@sanctology.com
                </a>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-3">
          <Reveal delay={150}>
            <ContactForm />
          </Reveal>
        </div>
      </section>

      <div className="h-20" />
    </>
  );
}
